/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { EventService, I18nService, LazyloadService } from '@dm/core';
import { productModelE } from 'app/common/constants';
import { GlobalDataService } from 'app/common/services';
import { ToolService } from 'app/common/services/tool.service';
import { type OEM } from 'app/common/types/oem';
import { FeatureConfig } from 'app/config/feature';
import { ShardSwitch, SWITCH } from 'app/config/switch';
import { QuickStartService } from 'app/feature/auth/quick-start/quick-start.service';

import { AboutInfoComponent } from './about-info/about-info.component';
import { HelpMenuStrService } from './help-menu-str.service';
import { intelligentCustomerServiceComponent } from './intelligent-customer-service/intelligent-customer-service.component';

@Component({
    selector: 'app-help-memu',
    templateUrl: './help-memu.component.html',
    styleUrls: ['./help-memu.component.scss'],
})
export class HelpMemuComponent implements OnInit {
    @Input() isSmallSize = false;

    @Output() onHidePanel = new EventEmitter();

    oem: OEM = (window as any).oem;

    isCruShow = true;

    i18nLabel = this.str.i18nLabel;

    helpUrl = this.str.getHelpUrl();

    isNotOem = this.oem.vendor === 'huawei';

    tooltipVisible = false;

    isZh = this.i18nService.language === 'zh';
    ShardSwitch = ShardSwitch;

    /**
     * 是否展示CRU更换教程，在i18n中找到型号对应url才展示
     */
    isShowUserReplaceableUnit = false;

    // dorado(不包含D2000，不包含dbStore),converge(包含入门级存储)，micro型号支持展示信息中心
    showSelfService = FeatureConfig.IsShowSelfService;

    isVstoreSystem = SWITCH.IS_VSTORE_SYSTEM;

    // 高端6800 6810 8000三个型号需要有CRU链接
    needCRUModels = [
        productModelE.V6_6800_829.value,
        productModelE.V6_6800_836.value,
        productModelE.V6_8000_823.value,
        productModelE.V6_8000_815.value,
        productModelE.V6_8000_816.value,
        productModelE.V6_6800_917.value,
        productModelE.V6_8000_911.value,
        productModelE.V6_8000_904.value,
        productModelE.V6_8000_905.value,
    ];
    SWITCH = SWITCH;
    FeatureConfig = FeatureConfig;

    get isSimpleMode(): boolean {
        return SWITCH.IS_SIMPLE_MODE;
    }

    constructor(
        private str: HelpMenuStrService,
        private eventService: EventService,
        private toolService: ToolService,
        private quickStartService: QuickStartService,
        private lazyloadService: LazyloadService,
        private globalDataService: GlobalDataService,
        private i18nService: I18nService,
    ) { }

    ngOnInit(): void {
        this.initDeviceInfo();

        // url不为空才展示cru更换视频教程
        this.isShowUserReplaceableUnit = Boolean(this.helpUrl.userReplaceableUnit);
    }

    initDeviceInfo(): void {
        this.eventService.subscribe('systemInfoUpdate', this.updateDeviceInfo);
        this.updateDeviceInfo();
    }

    updateDeviceInfo = (): void => {
        this.isCruShow = FeatureConfig.IsShowCRU;
    };

    aboutShowOn(): void {
        this.tooltipVisible = false;
        this.onHidePanel.emit();
        this.lazyloadService.appendComponent(AboutInfoComponent);
    }

    /**
     * 显示智能客服弹窗
     */
    showCustomerService(): void {
        this.tooltipVisible = false;
        this.onHidePanel.emit();
        this.lazyloadService.appendComponent(intelligentCustomerServiceComponent);
    }

    /**
     * 跳转新手引导页
     */
    openQuickStart(): void {
        const url = this.quickStartService.getQuickStartUrl();
        window.open(url, '_blank');
    }
}
